module.exports = __webpack_public_path__ + "img/IMG_3945_L_Wood_MockedUp.2b6ef95f.jpg";